import { apiInstanceFetch } from "../../util/api";
import { apiInstance } from "../../util/api-new";
import { CouponActionTypes } from "./coupon.type";

export const getCoupons = (start, limit, search) => async (dispatch) => {
  const queryParams = new URLSearchParams({
    start: start || 0,
    limit: limit || 20,
    ...(search && { search }),
  });

  apiInstanceFetch.get(`admin/coupons?${queryParams}`).then((res) => {
    if (res.status) {
      dispatch({
        type: CouponActionTypes.GET_COUPONS,
        payload: {
          coupons: res.data.coupons,
          total: res.data.pagination.total,
        },
      });
    }
  });
};

// Add Coupon
export const addCoupon = (payload) => (dispatch) => {
  apiInstanceFetch.post("admin/coupons", payload).then((res) => {
    if (res.status) {
      dispatch({
        type: CouponActionTypes.ADD_COUPON,
        payload: res.data,
      });
    }
  });
};

// Update Coupon
export const updateCoupon = (couponId, payload) => (dispatch) => {
  apiInstanceFetch.put(`admin/coupons/${couponId}`, payload).then((res) => {
    if (res.status) {
      dispatch({
        type: CouponActionTypes.UPDATE_COUPON,
        payload: res.data,
      });
    }
  });
};

// Delete Coupon
export const deleteCoupon = (couponId) => (dispatch) => {
  apiInstanceFetch.delete(`admin/coupons/${couponId}`).then((res) => {
    if (res.status) {
      dispatch({
        type: CouponActionTypes.DELETE_COUPON,
        payload: couponId,
      });
    }
  });
};

export const selectEditCoupon = (coupon) => ({
  type: CouponActionTypes.EDITING_COUPON,
  payload: coupon,
});

export const toggleCouponStatus = (couponId) => (dispatch) => {
  apiInstanceFetch.patch(`admin/coupons/${couponId}/toggle`).then((res) => {
    dispatch({
      type: CouponActionTypes.UPDATE_COUPON,
      payload: res.data,
    });
  });
};

export const applyCouponCode = async (
  couponCode,
  planId,
  organizationId,
  amount,
) => {
  const queryParams = new URLSearchParams({
    couponCode: couponCode,
    planId: planId,
    organizationId: organizationId,
    amount: amount,
  });

  return apiInstance.get(`coupons/apply?${queryParams}`).then((res) => {
    return res;
  });
};
